import "./dashboard-sections.css";
import { Droplets, Trash2, ShoppingBag } from "lucide-react";
import useTranslator from "../../../hooks/useTranslator";
import { formatNumber } from "../../../helpers/Utils";

const PerfRow = ({ label, value, valueColor, isLoading = false }) => (
  <div className="bd-perf-row">
    <span className="bd-perf-label">{label}</span>
    <span className="bd-perf-value" style={valueColor ? { color: valueColor } : {}}>
      {isLoading
        ? <span className="db-shimmer" style={{ height: 14, width: 60, display: "inline-block", verticalAlign: "middle" }} />
        : (value ?? "—")
      }
    </span>
  </div>
);

const SectionDivider = ({ title, icon }) => (
  <div className="lm-divider">
    {icon && <span className="lm-divider-icon">{icon}</span>}
    {title}
  </div>
);

const LossMetrics = ({ data = {}, isLoading = false }) => {
  const { _t } = useTranslator();

  const trashMetrics = [
    { label: _t("non_trash_prcnt_db", "Non-Trash %"),       key: "non_trash_prcnt",        color: "#25aa91" },
    { label: _t("total_trash_prcnt_db", "Total Trash %"),   key: "total_trash_prcnt",      color: "#e53935" },
    { label: _t("processing_loss_prcnt_db", "Processing Loss %"), key: "processing_trash_prcnt", color: "#ee7225" },
    { label: _t("sorting_loss_prcnt_db", "Sorting Loss %"), key: "sorting_trash_prcnt",    color: "#ee7225" },
  ];

  const kgTakenOffMetrics = data?.kg_taken_off_metrics ?? [];
  const trashRespData = data?.trash_metrics ?? [];
  const evpRespData = data?.evaporation_metrics ?? [];

  return (
    <div className="bd-right-col cmn_card">
      <div className="bd-perf-header">{_t("processing_metrics_db", "PROCESSING METRICS")}</div>

      <SectionDivider title={_t("evaporation_metrics_db", "Evaporation Metrics")} icon={<Droplets size={13} />} />
      <PerfRow label={_t("pct_in_maturity_db", "% In Maturity")}  value={evpRespData?.total_evaporation_prcnt ?? "0"} valueColor="#ee7225" isLoading={isLoading} />
      <PerfRow label={_t("assumed_kg_db", "Assumed KG")}          value={`${formatNumber(evpRespData?.total_evaporation_kg) ?? "0"} kg`}              isLoading={isLoading} />
      <PerfRow label={_t("assumed_cases_db", "Assumed Cases")}    value={evpRespData?.assumed_evaporation_cases ?? "0"}                 isLoading={isLoading} />

      <SectionDivider title={_t("trash_metrics_db", "Trash Metrics")} icon={<Trash2 size={13} />} />
      {trashMetrics.map((m, i) => (
        <PerfRow
          key={i}
          label={m.label}
          value={`${trashRespData?.[m.key] ?? "0"}%`}
          valueColor={m.color}
          isLoading={isLoading}
        />
      ))}

      <SectionDivider title={_t("kg_taken_off_db", "KG Taken Off")} icon={<ShoppingBag size={13} />} />
      <PerfRow label={_t("total_cheeks_kg_db", "Total Cheeks KG")} value={`${formatNumber(kgTakenOffMetrics?.total_cheeks_kg) ?? "0"} kg`}               isLoading={isLoading} />
      <PerfRow label={_t("total_strips_kg_db", "Total Strips KG")} value={`${formatNumber(kgTakenOffMetrics?.total_strips_kg) ?? "0"} kg`}               isLoading={isLoading} />
      <PerfRow label={_t("total_tapita_kg_db", "Total Tapita KG")} value={`${formatNumber(kgTakenOffMetrics?.total_tapita_kg) ?? "0"} kg`}               isLoading={isLoading} />
      <PerfRow label={_t("total_taken_off_db", "Total Taken Off")} value={`${formatNumber(kgTakenOffMetrics?.total_taken_off) ?? "0"} kg`} valueColor="#1d1f2c" isLoading={isLoading} />
    </div>
  );
};

export default LossMetrics;
